var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","min-height":"1100px"},attrs:{"src":_vm.url,"frameborder":"0"},on:{"load":_vm.handleIframe}})])}
var staticRenderFns = []

export { render, staticRenderFns }